import { connect } from 'react-redux';

import MagicLinkAccountSectionModalButton from './MagicLinkAccountSectionModalButton';
import { setShowModal, closeMagicLinkModal } from '../../actions/auth';

const _mapStateToProps = (state) => ({
    isLoading: state.frontend.isLoading,
    emailLinkAccount: state.authentication.emailLinkAccount,
    showModal: state.frontend.showModal,
});

const _mapDispatchToProps = {
    setShowModal,
    closeMagicLinkModal,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(MagicLinkAccountSectionModalButton);
